import type { JSXElementConstructor } from "react";

import {
  SPACE_DATE_RANGE,
  type SpaceDateRange,
} from "@/react/types/AiSummary/SpaceSummary";

export const RAILBAR_TYPES = {
  PARTICIPANTS: "PARTICIPANTS",
  CHAT_THREADS: "CHAT_THREADS",
  CHAT_ROOM_MESSAGE_SEARCH: "CHAT_ROOM_MESSAGE_SEARCH",
  CHAT_SPACE_SUMMARY: "CHAT_SPACE_SUMMARY",
  MEMBER_PROFILE: "MEMBER_PROFILE",
} as const;

export type RailbarType = keyof typeof RAILBAR_TYPES;

export interface RailbarContextValue {
  /** Whether this surface renders a railbar that can host a member profile. */
  canOpenMemberProfileRailbar: boolean;
  chatRoom: any;
  closeMemberProfileRailbar: () => void;
  closeSpaceSummaryRailbar: () => void;
  closeThreadsRailbar: () => void;
  dateRange: SpaceDateRange;
  EmbeddedRailbarComponent: JSXElementConstructor<any>;
  firstUnreadMessageId?: string;
  isChatSpace: boolean;
  isCourseSpace: boolean;
  isDmsPage: boolean;
  isDrawer: boolean;
  isLiveStream: boolean;
  isMessageSearchRailbarOpen: boolean;
  isPaddedByContainer: boolean;
  isUnifiedInbox: boolean;
  isUnifiedInboxChatThreadsPage: boolean;
  memberProfilePublicId: string | undefined;
  messageHashId: string | undefined;
  messageHighlightId: any;
  openMemberProfileRailbar: (memberPublicId: string) => void;
  openSpaceSummaryRailbar: (
    range: SpaceDateRange,
    firstUnreadMessageId?: string,
  ) => void;
  openThreadsRailbar: (message: any, chatRoom: any) => void;
  parentMessage: any;
  RailbarComponent: JSXElementConstructor<any>;
  setDateRange: (range: SpaceDateRange) => void;
  setMessageHighlightId: (messageId: any) => void;
  shouldShowEmbeddedRailBar: boolean;
  shouldShowRailBar: boolean;
  toggleChatRoomMessageSearchRailbar: () => void;
  toggleShowEmbeddedRailBar: () => void;
  toggleShowRailBar: () => void;
  type: RailbarType;
  updateParentMessage: (message: any) => void;
}

export const RAILBAR_INITIAL_STATE = {
  canOpenMemberProfileRailbar: false,
  chatRoom: null,
  closeMemberProfileRailbar: () => {},
  closeThreadsRailbar: () => {},
  memberProfilePublicId: undefined,
  openMemberProfileRailbar: () => {},
  isCourseSpace: false,
  isLiveStream: false,
  isUnifiedInbox: false,
  isUnifiedInboxChatThreadsPage: false,
  isDrawer: false,
  isPaddedByContainer: false,
  messageHighlightId: null,
  openThreadsRailbar: () => {},
  parentMessage: null,
  RailbarComponent: () => null,
  setMessageHighlightId: () => {},
  shouldShowRailBar: false,
  toggleShowRailBar: () => {},
  type: RAILBAR_TYPES.PARTICIPANTS,
  updateParentMessage: () => {},
  isChatSpace: false,
  isDmsPage: false,
  toggleChatRoomMessageSearchRailbar: () => {},
  isMessageSearchRailbarOpen: false,
  EmbeddedRailbarComponent: () => null,
  shouldShowEmbeddedRailBar: false,
  toggleShowEmbeddedRailBar: () => {},
  messageHashId: undefined,
  dateRange: SPACE_DATE_RANGE.LAST_7_DAYS,
  setDateRange: () => {},
  openSpaceSummaryRailbar: () => {},
  closeSpaceSummaryRailbar: () => {},
  firstUnreadMessageId: undefined,
};
